export interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data: Record<string, unknown>;
}

export default function SchemaOrg({ data }: SchemaOrgProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}